import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
             requestAnimationFrame(function() {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle('resize', 'optimizedResize');
})();

export default {
    finalize() {
        const dropdownToggle = $('.dropdown-toggle');
        const dropdownMenu = dropdownToggle.next('.dropdown-menu');
        const dlMenuMenuItem = $('.dl-menuwrapper .dl-submenu .menu-item');
        const headerSubnavigation = $('.header__subnavigation');
        const showHeaderSubnavigation = $('.header__back-menu,button.hamburger');

        let dropdownMenuItemLink = $('.dropdown-menu-item > li > a');

        // Sticky header
        var ScrollTriggerHeader = ScrollTrigger.create({
            trigger: $('.header'),
            top: 'top top',
            end: 9999999,
            pin: '.header__sticky',
            pinSpacing: false,
            toggleClass: {className: 'setPin', targets: '.header'},
        });
        ScrollTriggerHeader.refresh();


        //Scrollto Animate
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[data-toggle]').on('click',function(event) {
            var clicked_el = $(this);
            if (
                location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')  && location.hostname === this.hostname ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    var target_offset = target.offset().top;
                    var header_offset = $('.header.setPin .header__sticky').length ? $('.header.setPin .header__sticky').outerHeight() : 0;
                    var anchor_nav_offset = $('.anchor-nav-content__nav--sticky').length ? $('.anchor-nav-content__nav--sticky').outerHeight() : 0;

                    if(target.find('.block-office-location__single--collapse').length > 0) {
                        $(target.find('.block-office-location__single--collapse')).collapse('show');
                    }
                    $('html, body').on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function(){
                        $('html, body').stop();
                    });

                    $('html, body').animate({
                        scrollTop: target_offset - header_offset - anchor_nav_offset,
                    }, 1200, function() {
                        $('html, body').off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
                        if(clicked_el.attr('href').indexOf('#pills-') == -1) {
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(':focus')) {
                                return false;
                            } else {
                                $target.attr('tabindex','-1');
                                $target.focus();
                            }
                        }
                    });
                }
            }
        });

        // Button menu mobile
        $('.fc-toggle-menu-responsive').on('click', function() {
            if($('body').hasClass('menu-open')) {
                $('body').removeClass('menu-open');
                $(this).removeClass('is-active');
            } else {
                $('body').addClass('menu-open');
                $(this).addClass('is-active');
                // Scrollto pour coller le sticky header au top.
                if(!$('.header').hasClass('setPin')) {
                    $('html, body').animate({scrollTop: $('.header').position().top}, 400);
                }
            }
        });

        // Responsive modal custom backdrop
        $('.modal.modal-search').on('show.bs.modal', function () {
            setTimeout(function(){
                $('.modal-backdrop').addClass('custom-search-modalMenu');
            });
        });

        // Init responsive menu
        if($( '#dl-menu' ).length > 0){
            $( '#dl-menu' ).dlmenu({
                animationClasses : {
                    classin : 'dl-animate-in-2',
                    classout : 'dl-animate-out-2',
                },
                backLabek: window.tokilab_ajax_object.back_label,
                useActiveItemAsBackLabel: false,
                onLevelClick : () => {
                    $('.header__back-menu').addClass('is-visible');
                },
                resetOnClose: true,
            });
            setTimeout(() => {
                $('.menu-item.current-menu-ancestor.menu-item-has-children.has-sub', '#dl-menu').trigger('click');
            }, 1000);
        }
        $('#modalMenu').on('hide.bs.modal', () => {
            $('.header__back-menu').removeClass('is-visible');
        });
        $('#modalMenu').on('hidden.bs.modal', () => {
            $('.dl-subviewopen', '.dl-menuopen').find('.dl-back a').trigger('click');
        });
        function openFirstChild(){
            var submenu = $('.dl-submenu .menu-item-has-children');
            submenu.removeClass('active');
        }
        $('.menu-item-has-children').click(function (){
            var submenu = $(this).find('.menu-item-has-children');
            submenu.removeClass('active');
            submenu.first().addClass('active').find('ul').fadeIn();
        })
        $('.header__back-menu').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            $('.header__back-menu').removeClass('is-visible');
            $('.dl-back a', '.dl-subviewopen').trigger('click');
            openFirstChild();
        })

        window.addEventListener('optimizedResize', function() {
            if($( window ).width() > 992){
                $('.modal.modalMenu').modal('hide');
                $('body').removeClass('menu-open');
                $('.fc-toggle-menu-responsive').removeClass('is-active');
                $('.header__burger').toggleClass('is-open');
            }
        });

        // Add margin-bottom to block-generic-content__wrapper
        $.each($('.block-generic-content__wrapper'), function () {
            if($($(this).next()).length) {
                var next = $(this).next()[0];
                if($(next).hasClass('block-generic-content__wrapper') && !$(next).is(':not(.block-digital-assets__wrapper)')) {
                    $(this).css('margin-bottom','120px')
                }
                // if(!$($(this).next()[0]).hasClass('block-generic-content__wrapper').not('.block-digital-assets__wrapper')) {
                //     $(this).css('margin-bottom','120px')
                // }
            }
        });

        // Add slideDown animation to dropdown
        $('.dropdown').on('show.bs.dropdown', function(){
            $(this).find('.dropdown-menu').first().stop(true, true).fadeIn(300);
        });

        // Patch embed de vidéo dans wysiwyg
        $.each($('.wysiwyg iframe'), function () {
            if($(this).attr('src').includes('vimeo')) {
                $(this).addClass('embed-responsive-item');
                $(this).wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
            }
            if($(this).attr('src').includes('youtube')) {
                $(this).addClass('embed-responsive-item');
                $(this).wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
            }
        });

        // Patch visuel des tables dans wysiwyg
        $.each($('.wysiwyg table'), function () {
            $(this).addClass('table table-striped table-bordered');
            $(this).wrap('<div class="table-responsive"></div>');
        });

        // Fonctionnement video modal
        if($('.fc-show-modale-video').length > 0){
            $('.fc-show-modale-video').on('click', function(){
                $('#videoModal .embed-responsive').remove();
                var platform = $(this).attr('data-video-plateform');
                var video_id = $(this).attr('data-video-id');
                switch (platform) {
                    case 'youtube':
                        $('.video-modal__wrapper').append('<div class="embed-responsive embed-responsive-16by9"><iframe src="https://www.youtube.com/embed/' + video_id + '?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=1&amp;playsinline=1" frameborder="0" allowfullscreen allow="autoplay; fullscreen"></iframe></div>');
                        break;
                    case 'vimeo':
                        $('.video-modal__wrapper').append('<div class="embed-responsive embed-responsive-16by9"><iframe title="vimeo-player" src="https://player.vimeo.com/video/'+ video_id +'" frameborder="0" allowfullscreen></iframe></div>');
                        break;

                    default:
                        break;
                }
                if($(this).find('.tile-video__title').length > 0) {
                    $('#videoModal .video-modal__title').text($(this).find('.tile-video__title').text());
                } else if($(this).find('.howto__video--title').length > 0) {
                    $('#videoModal .video-modal__title').text($(this).find('.howto__video--title').text());
                }
            });

            $('#videoModal').on('hidden.bs.modal', function(){
                $('#videoModal .embed-responsive').remove();
                $('#videoModal .video-modal__title').text('');
            });
        }

      jQuery('.block-image-text__slider--slides .video__slide, .block-image-text__single .video__slide').click(function () {
        const url = jQuery(this).attr('data-video_url');
        const video = jQuery('#videoModal video')[0];
        const modal = jQuery('#videoModal');
        jQuery('#videoModal video source').attr('src', url);
        modal.modal('show');
        video.load();
        modal.on('hidden.bs.modal', function () {
          video.pause();
          video.currentTime = 0;
          jQuery('#videoModal video source').attr('src', '#');
        })
      });

        // Icons slider
        jQuery('.icons--slides').slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          autoplay: true,
          // autoplaySpeed: 1000,
          speed: 2000,
          dots: true,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
          ],
        });

      // Filter News
      jQuery('#tag_filter_wrapper a').click(function(e){
        e.preventDefault();
        const tag_id = jQuery(this).attr('data-term_id');
        var paged = 1;
        jQuery('#tag_filter').text(jQuery(this).text());
        jQuery.ajax({
          type: 'post',
          url: window.tokilab_ajax_object.ajax_url,
          data: {
            action: 'tag_filter',
            tag_id,
            paged,
          },
          success: function(response){
            jQuery('#news-content').hide().html(response).fadeIn();
            jQuery('#clear_filter').show();
            jQuery('.post-navigation__menu-wrapper a').click(function(e){
              e.preventDefault();
              var paged = jQuery(this).prop('href').split('?')[1];
              jQuery.ajax({
                type: 'post',
                url: window.tokilab_ajax_object.ajax_url,
                data: {
                  action: 'tag_filter',
                  tag_id,
                  paged,
                },
              });
            });
          },
        });
      });

      // Clear Filter News
      jQuery('#clear_filter').click(function () {
        jQuery.ajax({
          type: 'post',
          url: window.tokilab_ajax_object.ajax_url,
          data: {
            action: 'tag_filter',
          },
          success: function(response){
            jQuery('#news-content').hide().html(response).fadeIn();
            jQuery('#tag_filter').text('Filter by');
            jQuery('#clear_filter').hide();
          },
        });
      });

        // Image Tile Slider
        jQuery('.image-tile-slider--slides').slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: true,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
          ],
        });

        // image-text slider
        $('.block-image-text__slider--slides').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.block-image-text__slider--nav-slides',
        });

        $('.block-image-text__slider--nav-slides').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.block-image-text__slider--slides',
            dots: false,
            focusOnSelect: true,
            prevArrow:$('.block-image-text__slider--arrows').find('.slick-prev'),
            nextArrow:$('.block-image-text__slider--arrows').find('.slick-next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        infinite: true,
                    },
                },
            ],
        });

        if($('.fc-anchor-nav-content-nav').length) {
            const links = document.querySelectorAll('.fc-anchor-nav-content-nav .nav-link');
            const sections = document.querySelectorAll('.anchor-nav-content__tab');

            links.forEach((link) => {
                link.onclick = () => {
                    sections.forEach((section) => {
                        if (link.getAttribute('href') === '#' + section.id) {
                            document.documentElement.scrollTop = section.offsetTop;
                        }
                    });
                };
            });

            window.onscroll = () => {
                window.requestAnimationFrame(() => {
                    scrollspy()
                });
            };
            window.onload = () => scrollspy();
            window.onresize = () => scrollspy();

            const scrollspy = () => {
                const pageYPosition = document.documentElement.scrollTop || document.body.scrollTop;
                sections.forEach((section) => {
                    const sectionYPosition = section.offsetTop;
                    var top_offset = 2;
                    top_offset += $('.header__sticky').length ? $('.header__sticky').outerHeight() : 0;
                    top_offset += $('.anchor-nav-content__nav--sticky').length ? $('.anchor-nav-content__nav--sticky').outerHeight() : 0;

                    if (pageYPosition > sectionYPosition - top_offset) {
                        links.forEach((link) => {
                            if (link.getAttribute('href') === '#' + section.id) {
                                link.classList.add('active');
                            } else {
                                link.classList.remove('active');
                            }
                        });
                    }
                });
            };

            scrollspy();
        }

        $('.search a', '.header__main-menu--listing').on('click', function(){
            $('.fc-toggle-searchModal').trigger('click');
        });
        $('.fc-toggle-searchModal').on('click', function(e){
            e.preventDefault();
            $('#modal-search').modal('show');
        });
        // Ajax search
        $('.search-form__wrapper').each(function () {
            var $this = $(this);
            var searchRequest = null;
            var timeout = null;
            var minlength = 4;
            var modal_context = $this.parents('.modal-search').length;

            $('input[name="s"]', $this).on('keyup', function (event) {
                clearTimeout(timeout);
                var value = $(this).val();

                if (value.length > 1 ) {
                    $this.find('.fc-field-clear').fadeIn(300);
                } else {
                    $this.find('.fc-field-clear').fadeOut(300);
                }

                if(modal_context > 0) {
                    if(event.which == '13') {
                        if (searchRequest != null) {
                            searchRequest.abort();
                            $this.find('.search-form__field').removeClass('loading');
                        }
                        window.location.href = window.tokilab_ajax_object.search_base_url + encodeURI(value);
                    }
                    if (value.length >= minlength ) {
                        timeout = setTimeout(function() {
                            if (searchRequest != null) {
                                searchRequest.abort();
                                $this.find('.search-form__field').removeClass('loading');
                            }
                            var action = $this.attr('action');
                            $this.find('.search-form__field').addClass('loading');
                            searchRequest = $.ajax({
                                url: action,
                                type: 'POST',
                                data: {
                                    action: $this.find('input[name="action"]').val(),
                                    s: $this.find('input[name="s"]').val(),
                                    check : $this.find('input[name="b_610143e6cbd663edb869e5039_f35f3b0592"]').val(),
                                    nonce: $this.attr('nonce'),
                                },
                                success: function success(data) {
                                    $('.fc-ajax-search-results', '.modal-search').html(data);
                                    $('.modal-body', '.modal-search').stop().slideDown('slow');
                                    $this.find('.search-form__field').removeClass('loading');
                                },
                                // error: function error(data) {
                                //     console.log('error ajax', data);
                                // },
                            });
                            return false;
                        }, 1000);
                    } else if(value.length == 0) {
                        $('.fc-field-clear', $this).trigger('click');
                    }
                }
            });

            $('.fc-field-clear', $this).on('click', function() {
                $('input[name="s"]', $this).val('');
                $('input[name="s"]', $this).first().focus();
                $(this).fadeOut(300);
                $('.modal-body', '.modal-search').stop().slideUp('slow');
                if (searchRequest != null) {
                    searchRequest.abort();
                    $this.find('.search-form__field').removeClass('loading');
                }
            });
        });

        $('#modal-search').on('shown.bs.modal', function(){
            var $this = $(this);
            var fieldInput = $('input[name="s"]', $this).first();
            var fldLength= fieldInput.val().length;
            fieldInput.focus();
            fieldInput[0].setSelectionRange(fldLength, fldLength);
        })

        // Automatic add _blank on link
        $('a[href*="/en/technologies/silicon-carbide-membrane-solutions/"]').each(function() {
            $(this).attr('target', '_blank');
        });

        // Dropdowwn langues
        if($('.wpml-ls-item.menu-item-has-children').length > 0) {
            var $this = $('.wpml-ls-item.menu-item-has-children');
            $this.addClass('dropdown wpml__dropdown-toggle');
            $this.find('.sub-menu').addClass('dropdown-menu wpml__dropdown');
            $this.find('.sub-menu').find('a').addClass('dropdown-item');

            $this.on('focusout', function (e) {
                if(!e.target.classList.contains('dropdown-item')) {
                    if($this.find('.sub-menu').is(':visible')) {
                        $this.find('.sub-menu').first().stop(true, true).slideUp(200)
                        $this.removeClass('active');
                    }
                }
            });
            $this.on('click', function (e) {
                if((e.target.classList.contains('wpml-ls-native') && e.target.parentNode.classList.contains('dropdown-item')) || e.target.classList.contains('dropdown-item')) {
                    return;
                } else {
                    e.preventDefault();
                    if($this.find('.sub-menu').is(':visible')) {
                        $this.find('.sub-menu').first().stop(true, true).slideUp(200)
                        $this.removeClass('active');
                    } else {
                        $this.find('.sub-menu').first().stop(true, true).slideDown(200)
                        $this.addClass('active');
                    }
                }
            });
        }

        // Update menu responsive pour dropdown langues
        $('#dl-menu .dl-menu').find('.contact.menu-item').appendTo($('#dl-menu .dl-menu'));
        // Fix $('.wpml__dropdown-toggle > a')[0].outerHTML undefined
        if($('.wpml__dropdown-toggle > a')[0]) {
            $('<li class="menu-item wpml-ls-item active">' + $('.wpml__dropdown-toggle > a')[0].outerHTML + '</li>').insertBefore($('#dl-menu .dl-menu .wpml__dropdown-toggle .dl-submenu .dl-back').next());
        }

        /**
         * Submenu children &
         * Avoid subMenu closing each click
         */

        dropdownToggle.on('click', function() {
            dropdownMenu.stop(true, true).fadeOut(300);
        });

        dropdownMenuItemLink.on('click', function(e) {
            e.stopPropagation();

            let $this = $(this);

            if($this.attr('href') !== '#') {
                return;
            }

            if($this.parent('.menu-item').find('> ul').is(':visible')) {
                return false;
            }

            $this.closest('.dropdown-menu-item').find('> li > ul').fadeOut();
            $this.closest('.menu-item').find('> ul').fadeIn();

            $(document).click(function(){
                dropdownMenu.hide();
            });
        });

        dlMenuMenuItem.on('click', function() {
            let notThis = dlMenuMenuItem.not(this);
            let $this = $(this);

            // headerSubnavigation.hide();
            notThis.removeClass('active');
            notThis.find('> ul').fadeOut();

            if(!$this.hasClass('active')) {
                if($this.find('> ul').is(':visible')) {
                    $this.find('> ul').fadeOut();

                    return;
                }

                $this.find('> ul').removeAttr('style');
                $this.addClass('active');

                return;
            }

            $this.removeClass('active');
            $this.find('> ul').hide();

            showHeaderSubnavigation.on('click', function() {
                headerSubnavigation.removeAttr('style');
            });
        })
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js